import { Box, Divider, FormLabel } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ContractDurationField } from "./ContractDurationField";
import { ContractOptionsField } from "./ContractOptionsField";
import { FrameworkAgreementField } from "./FrameworkAgreementField";
import { FrameworkOverFourYearsField, FrameworkOverFourYearsPointer } from "./FrameworkOverFourYearsField";

interface Props {
  eventId: string;
}

export const ContractPeriodSection = ({ eventId }: Props) => {
  const { t } = useTranslation();

  return (
    <Box borderWidth="1px" borderRadius="lg" p="5" mb="8">
      <FormLabel fontWeight="bold" fontSize="md" mb="4">{t("Contract period")}</FormLabel>
      <ContractDurationField eventId={eventId} />
      <FrameworkOverFourYearsPointer eventId={eventId} />
      <ContractOptionsField eventId={eventId} />
      <Divider my="4" />
      <FrameworkAgreementField eventId={eventId} />
      <FrameworkOverFourYearsField eventId={eventId} />
    </Box>
  );
};
